import { v4 as uuidv4 } from 'uuid';
import URLSafeBase64 from 'urlsafe-base64';

export default function() {
  return URLSafeBase64.encode(uuidv4());
}
